import { render, staticRenderFns } from "./BindAccount.vue?vue&type=template&id=29a74312&scoped=true&"
import script from "./BindAccount.vue?vue&type=script&lang=js&"
export * from "./BindAccount.vue?vue&type=script&lang=js&"
import style0 from "./BindAccount.vue?vue&type=style&index=0&id=29a74312&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a74312",
  null
  
)

export default component.exports